import { MONTHLY } from '@constants/billingPeriods'
import { CurrenciesType, PLN } from '@constants/currencies'
import { defaultLitePlan } from '@constants/plans'
import { convertPriceToNetto, getPackagePrice } from '@helpers/payment'
import { GetPackagesTypes } from '@services/payments/useGetPackages'

export const getMonthlyLitePlanPrice = ({
  packages,
  accountCurrency
}: {
  packages: GetPackagesTypes[]
  accountCurrency: CurrenciesType
}) => {
  const getGrossPrice = getPackagePrice({
    packages: packages ?? [],
    periodToFind: MONTHLY,
    currencyToFind: accountCurrency,
    packageRecordKey: defaultLitePlan
  })

  return accountCurrency === PLN
    ? convertPriceToNetto(getGrossPrice)
    : getGrossPrice
}
